export const getInitialState = () => ({
    sanctions: undefined
});
